import { AxiosError, AxiosResponse } from "axios";

export const getMockData = (
  error: AxiosError
): Promise<AxiosError | AxiosResponse> => {
  return Promise.reject(error);
};
  